import * as i1 from '@niceltd/cxone-components/checkbox';
import { CheckboxModule } from '@niceltd/cxone-components/checkbox';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i3$1 from '@angular/forms';
import { Validators, NG_VALUE_ACCESSOR, NG_VALIDATORS, FormsModule } from '@angular/forms';
import * as i0 from '@angular/core';
import { Pipe, EventEmitter, Component, ViewEncapsulation, ChangeDetectionStrategy, Input, Output, QueryList, forwardRef, ElementRef, ViewChild, ViewChildren, HostListener, NgModule } from '@angular/core';
import * as i2 from '@niceltd/cxone-components/translation';
import { TranslationModule } from '@niceltd/cxone-components/translation';
import { SvgIcons, ComponentKeys } from '@niceltd/cxone-components/shared-services';
import { trigger, state, style, transition, animate } from '@angular/animations';
import * as i1$1 from '@angular/platform-browser';
import * as i5 from '@niceltd/cxone-components/spinner';
import { SpinnerModule } from '@niceltd/cxone-components/spinner';
import * as i6 from '@niceltd/cxone-components/text-input';
import { TextInputModule } from '@niceltd/cxone-components/text-input';
import * as i4 from '@niceltd/cxone-components/overflow-tooltip';
import { OverflowTooltipModule } from '@niceltd/cxone-components/overflow-tooltip';
import * as i8 from '@niceltd/cxone-components/infinite-scrolling';
import { InfiniteScrollingModule } from '@niceltd/cxone-components/infinite-scrolling';
import * as i9 from '@niceltd/cxone-components/selected-tags';
import { SelectedTagsModule } from '@niceltd/cxone-components/selected-tags';
import { SvgSpriteIconModule } from '@niceltd/cxone-components/svg-sprite-icon';
import { I18NEXT_NAMESPACE } from 'angular-i18next';
const _c0 = a0 => ({
  "disabled": a0
});
function MultiselectDropdownItemComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function MultiselectDropdownItemComponent_div_2_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r4 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r4.maxSelectionLimit && ctx_r4.isMaxItemsSelected && !ctx_r4.isSelected ? "" : ctx_r4.onToggleItem(ctx_r4.item));
    });
    i0.ɵɵpipe(1, "highlight");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const _r3 = i0.ɵɵreference(5);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 5, ctx_r0.item[ctx_r0.label], ctx_r0.query), i0.ɵɵsanitizeHtml)("tooltipContent", _r3)("tooltipPlacement", ctx_r0.isFirst ? "bottom" : "top")("ngClass", i0.ɵɵpureFunction1(8, _c0, ctx_r0.item.isDisabled === true));
    i0.ɵɵattribute("aria-label", ctx_r0.item[ctx_r0.label]);
  }
}
function MultiselectDropdownItemComponent_div_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
const _c1 = (a0, a1) => ({
  $implicit: a0,
  query: a1
});
function MultiselectDropdownItemComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, MultiselectDropdownItemComponent_div_3_ng_container_1_Template, 1, 0, "ng-container", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.template)("ngTemplateOutletContext", i0.ɵɵpureFunction2(2, _c1, ctx_r1.item, ctx_r1.query));
  }
}
function MultiselectDropdownItemComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 7);
    i0.ɵɵpipe(1, "highlight");
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, ctx_r2.item[ctx_r2.label], ctx_r2.query), i0.ɵɵsanitizeHtml);
  }
}
const _c2 = (a0, a1, a2, a3) => ({
  "border": a0,
  "selected": a1,
  "deselected": a2,
  "disabled": a3
});
const _c3 = ["dropdownElement"];
const _c4 = ["dropdownButton"];
const _c5 = ["placeholderEl"];
const _c6 = ["inputEl"];
const _c7 = ["invisibleItem"];
function MultiselectDropdownComponent_ng_container_4_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MultiselectDropdownComponent_ng_container_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "cxone-selected-tags", 7);
    i0.ɵɵlistener("click", function MultiselectDropdownComponent_ng_container_4_Template_cxone_selected_tags_click_1_listener($event) {
      return $event.stopPropagation();
    })("viewMoreClicked", function MultiselectDropdownComponent_ng_container_4_Template_cxone_selected_tags_viewMoreClicked_1_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r9 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r9.closeDropdownOnShowMoreClicked());
    })("tagDeleted", function MultiselectDropdownComponent_ng_container_4_Template_cxone_selected_tags_tagDeleted_1_listener($event) {
      i0.ɵɵrestoreView(_r10);
      const ctx_r11 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r11.deleteTag($event));
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(2, MultiselectDropdownComponent_ng_container_4_ng_container_2_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    const _r6 = i0.ɵɵreference(8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("tagsHeaderTemplate", ctx_r2.tagsHeaderTemplate)("maxTagsToDisplay", ctx_r2.maxTagsToDisplay)("removable", true)("tagsSource", ctx_r2.selectedTags)("primaryKey", ctx_r2.primaryKey)("label", ctx_r2.label);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", _r6);
  }
}
function MultiselectDropdownComponent_ng_container_5_span_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", null, 14);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r14 = ctx.$implicit;
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(item_r14[ctx_r13.label]);
  }
}
const _c8 = (a0, a1) => ({
  "dropdown-open": a0,
  "dropdown-closed": a1
});
function MultiselectDropdownComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 9, 10);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 11);
    i0.ɵɵtemplate(5, MultiselectDropdownComponent_ng_container_5_span_5_Template, 3, 1, "span", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(6, "i", 13);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r3.getPlaceholder());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r3.selection);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(4, _c8, ctx_r3.isDropdownOpen, !ctx_r3.isDropdownOpen))("innerHTML", ctx_r3.icons.arrow, i0.ɵɵsanitizeHtml);
  }
}
function MultiselectDropdownComponent_div_6_ng_container_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function MultiselectDropdownComponent_div_6_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, MultiselectDropdownComponent_div_6_ng_container_1_ng_container_1_Template, 1, 0, "ng-container", 8);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r6 = i0.ɵɵreference(8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", _r6);
  }
}
function MultiselectDropdownComponent_div_6_div_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 21)(1, "span", 22);
    i0.ɵɵlistener("click", function MultiselectDropdownComponent_div_6_div_2_Template_span_click_1_listener() {
      i0.ɵɵrestoreView(_r25);
      const ctx_r24 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r24.onSelectAll());
    })("keydown.enter", function MultiselectDropdownComponent_div_6_div_2_Template_span_keydown_enter_1_listener() {
      i0.ɵɵrestoreView(_r25);
      const ctx_r26 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r26.onSelectAll());
    });
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "span", 23);
    i0.ɵɵlistener("click", function MultiselectDropdownComponent_div_6_div_2_Template_span_click_5_listener() {
      i0.ɵɵrestoreView(_r25);
      const ctx_r27 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r27.onClearAll());
    })("keydown.enter", function MultiselectDropdownComponent_div_6_div_2_Template_span_keydown_enter_5_listener() {
      i0.ɵɵrestoreView(_r25);
      const ctx_r28 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r28.onClearAll());
    });
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c0, ctx_r17.selection.length === ctx_r17.options.length));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 6, "cxone-components.dropdowns.selectall"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(4, 8, "cxone-components.dropdowns.selectall"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c0, ctx_r17.selection.length === 0));
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(6, 10, "cxone-components.dropdowns.clearall"));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 12, "cxone-components.dropdowns.clearall"));
  }
}
function MultiselectDropdownComponent_div_6_div_3_cxone_multiselect_dropdown_item_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cxone-multiselect-dropdown-item", 26);
    i0.ɵɵlistener("toggleItem", function MultiselectDropdownComponent_div_6_div_3_cxone_multiselect_dropdown_item_1_Template_cxone_multiselect_dropdown_item_toggleItem_0_listener($event) {
      i0.ɵɵrestoreView(_r34);
      const ctx_r33 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r33.toggleItem($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r31 = ctx.$implicit;
    const isFirst_r32 = ctx.first;
    const ctx_r29 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("item", item_r31)("query", ctx_r29.query)("maxSelectionLimit", ctx_r29.maxSelectionLimit)("isMaxItemsSelected", ctx_r29.isMaxItemsSelected)("label", ctx_r29.label)("template", ctx_r29.template)("isFirst", isFirst_r32)("isSelected", item_r31.selected);
  }
}
function MultiselectDropdownComponent_div_6_div_3_div_3_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 30);
    i0.ɵɵpipe(1, "highlight");
  }
  if (rf & 2) {
    const category_r35 = i0.ɵɵnextContext().$implicit;
    const ctx_r37 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", i0.ɵɵpipeBind2(1, 1, category_r35.name, ctx_r37.query), i0.ɵɵsanitizeHtml);
  }
}
function MultiselectDropdownComponent_div_6_div_3_div_3_cxone_multiselect_dropdown_item_6_Template(rf, ctx) {
  if (rf & 1) {
    const _r44 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cxone-multiselect-dropdown-item", 26);
    i0.ɵɵlistener("toggleItem", function MultiselectDropdownComponent_div_6_div_3_div_3_cxone_multiselect_dropdown_item_6_Template_cxone_multiselect_dropdown_item_toggleItem_0_listener($event) {
      i0.ɵɵrestoreView(_r44);
      const ctx_r43 = i0.ɵɵnextContext(4);
      return i0.ɵɵresetView(ctx_r43.toggleItem($event));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r41 = ctx.$implicit;
    const ctx_r39 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("item", item_r41)("query", ctx_r39.query)("maxSelectionLimit", ctx_r39.maxSelectionLimit)("isMaxItemsSelected", ctx_r39.isMaxItemsSelected)("label", ctx_r39.label)("template", ctx_r39.template)("isFirst", false)("isSelected", item_r41.selected);
  }
}
function MultiselectDropdownComponent_div_6_div_3_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 27)(2, "span", 28);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(4, MultiselectDropdownComponent_div_6_div_3_div_3_ng_template_4_Template, 2, 4, "ng-template", null, 29, i0.ɵɵtemplateRefExtractor)(6, MultiselectDropdownComponent_div_6_div_3_div_3_cxone_multiselect_dropdown_item_6_Template, 1, 8, "cxone-multiselect-dropdown-item", 25);
    i0.ɵɵpipe(7, "slice");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const category_r35 = ctx.$implicit;
    const isFirstCategory_r36 = ctx.first;
    const _r38 = i0.ɵɵreference(5);
    const ctx_r30 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("tooltipPlacement", isFirstCategory_r36 && ctx_r30.isListWithCategoryFirst ? "bottom" : "top")("tooltipContent", _r38);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(category_r35.name);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(7, 5, category_r35.items, 0, ctx_r30.maxItemsToDisplay))("ngForTrackBy", ctx_r30.trackByFn);
  }
}
function MultiselectDropdownComponent_div_6_div_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r46 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24);
    i0.ɵɵlistener("scrollEvent", function MultiselectDropdownComponent_div_6_div_3_Template_div_scrollEvent_0_listener() {
      i0.ɵɵrestoreView(_r46);
      const ctx_r45 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r45.onScroll());
    })("endScroll", function MultiselectDropdownComponent_div_6_div_3_Template_div_endScroll_0_listener() {
      i0.ɵɵrestoreView(_r46);
      const ctx_r47 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r47.loadMoreData());
    });
    i0.ɵɵtemplate(1, MultiselectDropdownComponent_div_6_div_3_cxone_multiselect_dropdown_item_1_Template, 1, 8, "cxone-multiselect-dropdown-item", 25);
    i0.ɵɵpipe(2, "slice");
    i0.ɵɵtemplate(3, MultiselectDropdownComponent_div_6_div_3_div_3_Template, 8, 9, "div", 12);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(2, 3, ctx_r18.filteredList, 0, ctx_r18.maxItemsToDisplay))("ngForTrackBy", ctx_r18.trackByFn);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r18.filteredListWithCategory);
  }
}
function MultiselectDropdownComponent_div_6_div_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 31);
    i0.ɵɵelement(1, "cxone-spinner", 32);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r19 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("isSpinner", ctx_r19.isLoading);
  }
}
function MultiselectDropdownComponent_div_6_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 33)(1, "span", 34);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 1, "cxone-components.dropdowns.noresults"));
  }
}
const _c9 = (a0, a1) => ({
  count: a0,
  total: a1
});
function MultiselectDropdownComponent_div_6_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35)(1, "div", 36)(2, "div", 37);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 1, "cxone-components.dropdowns.footerText", i0.ɵɵpureFunction2(4, _c9, ctx_r21.options.length > ctx_r21.maxItemsToDisplay ? ctx_r21.maxItemsToDisplay : ctx_r21.options.length, ctx_r21.options.length)), " ");
  }
}
function MultiselectDropdownComponent_div_6_div_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35)(1, "div", 36)(2, "div", 37);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(4, 1, "cxone-components.dropdowns.footerText", i0.ɵɵpureFunction2(4, _c9, ctx_r22.options.length > ctx_r22.maxItemsToDisplay ? ctx_r22.maxItemsToDisplay : ctx_r22.options.length, ctx_r22.serverSideSearch.resultsCount)), " ");
  }
}
const _c10 = a0 => ({
  "top": a0
});
function MultiselectDropdownComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 15);
    i0.ɵɵtemplate(1, MultiselectDropdownComponent_div_6_ng_container_1_Template, 2, 1, "ng-container", 4)(2, MultiselectDropdownComponent_div_6_div_2_Template, 9, 18, "div", 16)(3, MultiselectDropdownComponent_div_6_div_3_Template, 4, 7, "div", 17)(4, MultiselectDropdownComponent_div_6_div_4_Template, 2, 1, "div", 18)(5, MultiselectDropdownComponent_div_6_div_5_Template, 4, 3, "div", 19)(6, MultiselectDropdownComponent_div_6_div_6_Template, 5, 7, "div", 20)(7, MultiselectDropdownComponent_div_6_div_7_Template, 5, 7, "div", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngStyle", i0.ɵɵpureFunction1(8, _c10, ctx_r4.dropdownTopPaddingFromTags + "px"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r4.displayTags);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.bulkOperations && ctx_r4.query.length === 0 && !ctx_r4.isLoading && !ctx_r4.maxSelectionLimit);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r4.isLoading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.isLoading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.query.length !== 0 && ctx_r4.filteredList.length === 0 && ctx_r4.filteredListWithCategory.length === 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.query.length === 0 && ctx_r4.isLoading === false && ctx_r4.serverSideSearch === undefined && ctx_r4.showFooter);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r4.serverSideSearch !== undefined && ctx_r4.serverSideSearch.enabled === true && ctx_r4.isLoading === false && ctx_r4.showFooter);
  }
}
function MultiselectDropdownComponent_ng_template_7_div_0_i_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r54 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 45);
    i0.ɵɵlistener("keydown.enter", function MultiselectDropdownComponent_ng_template_7_div_0_i_5_Template_i_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r54);
      const ctx_r53 = i0.ɵɵnextContext(3);
      ctx_r53.clearQuery($event);
      return i0.ɵɵresetView(ctx_r53.loadDropdown());
    })("click", function MultiselectDropdownComponent_ng_template_7_div_0_i_5_Template_i_click_0_listener($event) {
      i0.ɵɵrestoreView(_r54);
      const ctx_r55 = i0.ɵɵnextContext(3);
      ctx_r55.clearQuery($event);
      return i0.ɵɵresetView(ctx_r55.loadDropdown());
    });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r51 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", ctx_r51.icons.close, i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "cxone-components.dropdowns.clearQuery"));
  }
}
function MultiselectDropdownComponent_ng_template_7_div_0_i_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 46);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r52 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", ctx_r52.icons.search, i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "cxone-components.dropdowns.searchQuery"));
  }
}
function MultiselectDropdownComponent_ng_template_7_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r57 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 40);
    i0.ɵɵlistener("click", function MultiselectDropdownComponent_ng_template_7_div_0_Template_div_click_0_listener($event) {
      i0.ɵɵrestoreView(_r57);
      const ctx_r56 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r56.onTagsSearchClick($event));
    });
    i0.ɵɵelementStart(1, "cxone-text-input", 41, 42);
    i0.ɵɵtwoWayListener("ngModelChange", function MultiselectDropdownComponent_ng_template_7_div_0_Template_cxone_text_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r57);
      const ctx_r58 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r58.query, $event) || (ctx_r58.query = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("keyup", function MultiselectDropdownComponent_ng_template_7_div_0_Template_cxone_text_input_keyup_1_listener($event) {
      i0.ɵɵrestoreView(_r57);
      const ctx_r59 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r59.onSearch($event));
    });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵpipe(4, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, MultiselectDropdownComponent_ng_template_7_div_0_i_5_Template, 2, 4, "i", 43)(6, MultiselectDropdownComponent_ng_template_7_div_0_i_6_Template, 2, 4, "i", 44);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r48 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(4, 7, "cxone-components.dropdowns.search"));
    i0.ɵɵtwoWayProperty("ngModel", ctx_r48.query);
    i0.ɵɵproperty("accessLabel", i0.ɵɵpipeBind1(3, 5, "cxone-components.dropdowns.searchingFor"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r48.query && ctx_r48.query.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r48.query.length === 0);
  }
}
function MultiselectDropdownComponent_ng_template_7_div_1_i_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r64 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "i", 50);
    i0.ɵɵlistener("keydown.enter", function MultiselectDropdownComponent_ng_template_7_div_1_i_4_Template_i_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r64);
      const ctx_r63 = i0.ɵɵnextContext(3);
      ctx_r63.clearQuery($event);
      return i0.ɵɵresetView(ctx_r63.loadDropdown());
    })("click", function MultiselectDropdownComponent_ng_template_7_div_1_i_4_Template_i_click_0_listener($event) {
      i0.ɵɵrestoreView(_r64);
      const ctx_r65 = i0.ɵɵnextContext(3);
      ctx_r65.clearQuery($event);
      return i0.ɵɵresetView(ctx_r65.loadDropdown());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r61 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", ctx_r61.icons.close, i0.ɵɵsanitizeHtml);
  }
}
function MultiselectDropdownComponent_ng_template_7_div_1_i_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "i", 46);
    i0.ɵɵpipe(1, "translate");
  }
  if (rf & 2) {
    const ctx_r62 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("innerHTML", ctx_r62.icons.search, i0.ɵɵsanitizeHtml);
    i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(1, 2, "cxone-components.dropdowns.clearQuery"));
  }
}
function MultiselectDropdownComponent_ng_template_7_div_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r67 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 47)(1, "cxone-text-input", 48, 42);
    i0.ɵɵtwoWayListener("ngModelChange", function MultiselectDropdownComponent_ng_template_7_div_1_Template_cxone_text_input_ngModelChange_1_listener($event) {
      i0.ɵɵrestoreView(_r67);
      const ctx_r66 = i0.ɵɵnextContext(2);
      i0.ɵɵtwoWayBindingSet(ctx_r66.query, $event) || (ctx_r66.query = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("keyup", function MultiselectDropdownComponent_ng_template_7_div_1_Template_cxone_text_input_keyup_1_listener($event) {
      i0.ɵɵrestoreView(_r67);
      const ctx_r68 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r68.onSearch($event));
    });
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, MultiselectDropdownComponent_ng_template_7_div_1_i_4_Template, 1, 1, "i", 49)(5, MultiselectDropdownComponent_ng_template_7_div_1_i_5_Template, 2, 4, "i", 44);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r49 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(3, 5, "cxone-components.dropdowns.search"));
    i0.ɵɵtwoWayProperty("ngModel", ctx_r49.query);
    i0.ɵɵproperty("accessLabel", "Search");
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r49.query && ctx_r49.query.length > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r49.query.length === 0);
  }
}
function MultiselectDropdownComponent_ng_template_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, MultiselectDropdownComponent_ng_template_7_div_0_Template, 7, 9, "div", 38)(1, MultiselectDropdownComponent_ng_template_7_div_1_Template, 6, 7, "div", 39);
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r5.isLoading && ctx_r5.search && ctx_r5.serverSideSearch === undefined);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r5.search && ctx_r5.serverSideSearch !== undefined && ctx_r5.serverSideSearch.enabled === true);
  }
}
const _c11 = a0 => ({
  "expanded": a0
});
const _c12 = (a0, a1, a2) => ({
  "disabled": a0,
  "required": a1,
  "custom-max-tags": a2
});
class HighlightPipe {
  transform(text, ...args) {
    const query = args[0];
    if (query) {
      const index = text.toLowerCase().indexOf(query.toLowerCase());
      if (index !== -1) {
        text = text.substring(0, index) + '<span class="highlighted">' + text.substr(index, query.length) + '</span>' + text.substring(index + query.length, text.length);
      }
    }
    return text;
  }
  /** @nocollapse */
  static {
    this.ɵfac = function HighlightPipe_Factory(t) {
      return new (t || HighlightPipe)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "highlight",
      type: HighlightPipe,
      pure: true
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HighlightPipe, [{
    type: Pipe,
    args: [{
      name: 'highlight'
    }]
  }], null, null);
})();
class MultiselectDropdownItemComponent {
  constructor() {
    this.item = {};
    this.query = '';
    this.toggleItem = new EventEmitter();
  }
  onToggleItem(item) {
    this.toggleItem.emit(item);
  }
  /** @nocollapse */
  static {
    this.ɵfac = function MultiselectDropdownItemComponent_Factory(t) {
      return new (t || MultiselectDropdownItemComponent)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MultiselectDropdownItemComponent,
      selectors: [["cxone-multiselect-dropdown-item"]],
      inputs: {
        item: "item",
        query: "query",
        maxSelectionLimit: "maxSelectionLimit",
        isMaxItemsSelected: "isMaxItemsSelected",
        label: "label",
        template: "template",
        isFirst: "isFirst",
        isSelected: "isSelected"
      },
      outputs: {
        toggleItem: "toggleItem"
      },
      decls: 6,
      vars: 11,
      consts: [["tabindex", "0", 1, "item-row", 3, "ngClass"], [3, "ngModel", "disabled", "ariaLabel", "ngModelChange", "clicked"], ["class", "item-text", "cxoneOverflowTooltip", "", "value", "top", "name", "placement", 3, "innerHTML", "tooltipContent", "tooltipPlacement", "ngClass", "click", 4, "ngIf"], [4, "ngIf"], ["tooltipTemplate", ""], ["cxoneOverflowTooltip", "", "value", "top", "name", "placement", 1, "item-text", 3, "innerHTML", "tooltipContent", "tooltipPlacement", "ngClass", "click"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [3, "innerHTML"]],
      template: function MultiselectDropdownItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "cxone-checkbox", 1);
          i0.ɵɵtwoWayListener("ngModelChange", function MultiselectDropdownItemComponent_Template_cxone_checkbox_ngModelChange_1_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.isSelected, $event) || (ctx.isSelected = $event);
            return $event;
          });
          i0.ɵɵlistener("clicked", function MultiselectDropdownItemComponent_Template_cxone_checkbox_clicked_1_listener() {
            return ctx.maxSelectionLimit && ctx.isMaxItemsSelected && !ctx.isSelected ? "" : ctx.onToggleItem(ctx.item);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(2, MultiselectDropdownItemComponent_div_2_Template, 2, 10, "div", 2)(3, MultiselectDropdownItemComponent_div_3_Template, 2, 5, "div", 3)(4, MultiselectDropdownItemComponent_ng_template_4_Template, 2, 4, "ng-template", null, 4, i0.ɵɵtemplateRefExtractor);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(6, _c2, ctx.item.border && ctx.query.length === 0, ctx.isSelected, !ctx.isSelected, ctx.maxSelectionLimit && ctx.isMaxItemsSelected && !ctx.isSelected));
          i0.ɵɵadvance();
          i0.ɵɵtwoWayProperty("ngModel", ctx.isSelected);
          i0.ɵɵproperty("disabled", ctx.maxSelectionLimit && ctx.isMaxItemsSelected && !ctx.isSelected)("ariaLabel", ctx.item[ctx.label]);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.template);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.template);
        }
      },
      dependencies: [i1.CheckboxComponent, i3.NgClass, i3.NgIf, i3.NgTemplateOutlet, i3$1.NgControlStatus, i3$1.NgModel, i4.OverflowTooltipDirective, HighlightPipe],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiselectDropdownItemComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-multiselect-dropdown-item',
      encapsulation: ViewEncapsulation.None,
      changeDetection: ChangeDetectionStrategy.OnPush,
      template: "<div class=\"item-row\" tabindex=\"0\"\n  [ngClass]=\"{'border': item.border && query.length === 0 , 'selected': isSelected, 'deselected': !isSelected, 'disabled' : maxSelectionLimit && isMaxItemsSelected && !isSelected}\"\n  >\n  <cxone-checkbox [(ngModel)]=\"isSelected\" (clicked)=\"maxSelectionLimit && isMaxItemsSelected && !isSelected ? '' : onToggleItem(item) \"\n    [disabled]=\"maxSelectionLimit && isMaxItemsSelected && !isSelected\"  [ariaLabel]=\"item[label]\">\n  </cxone-checkbox>\n  <div class=\"item-text\" [innerHTML]=\"item[label]|highlight:query\" [attr.aria-label]=\"item[label]\"\n       cxoneOverflowTooltip [tooltipContent]=\"tooltipTemplate\" value=\"top\" name=\"placement\"\n       [tooltipPlacement]=\"isFirst ? 'bottom' : 'top'\" *ngIf=\"!template\"\n       (click)=\"maxSelectionLimit && isMaxItemsSelected && !isSelected ? '' : onToggleItem(item) \"\n      [ngClass]=\"{'disabled': item.isDisabled === true}\"></div>\n  <div *ngIf=\"template\">\n    <ng-container *ngTemplateOutlet=\"template; context: { $implicit: item, query: query }\"></ng-container>\n  </div>\n  <ng-template #tooltipTemplate><span [innerHTML]=\"item[label]|highlight:query\"></span></ng-template>\n</div>\n"
    }]
  }], null, {
    item: [{
      type: Input
    }],
    query: [{
      type: Input
    }],
    maxSelectionLimit: [{
      type: Input
    }],
    isMaxItemsSelected: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    template: [{
      type: Input
    }],
    isFirst: [{
      type: Input
    }],
    isSelected: [{
      type: Input
    }],
    toggleItem: [{
      type: Output
    }]
  });
})();
class MultiselectDropdownComponent {
  constructor(sanitizer, cd, translate) {
    this.sanitizer = sanitizer;
    this.cd = cd;
    this.translate = translate;
    this.bulkOperations = true;
    this.isLoading = false;
    this.isRequired = false;
    this.label = 'name';
    this.maxItemsToDisplay = 200;
    this.options = [];
    this.placeholder = this.translate.transform('cxone-components.dropdowns.defaultPlaceholder.multiple');
    this.primaryKey = 'id';
    this.search = true;
    this.sortOrder = 'asc';
    this.showFooter = true;
    this.enableInfiniteScroll = false;
    this.displayTags = false;
    this.selection = [];
    this.dropdownOpened = new EventEmitter();
    this.dropdownClosed = new EventEmitter();
    this.selectionChanged = new EventEmitter();
    this.onServerSideSearch = new EventEmitter();
    this.onLoadData = new EventEmitter();
    this.scroll = new EventEmitter();
    this.invisibleItemsRef = new QueryList();
    this.disabled = false;
    this.selectedTags = [];
    this.displayedOptions = [];
    this.dropdownTouched = false;
    this.isDropdownOpen = false;
    this.query = '';
    this.icons = {};
    this.transitionOptions = '300ms cubic-bezier(0.86, 0, 0.07, 1)';
    this.animating = false;
    this.showCount = false;
    this.isMaxItemsSelected = false;
    this.selectAll = false;
    this.deselectedOptions = [];
    this.defaultKeystrokedelay = 500;
    this.defaultResultscount = 0;
    this.dropdownTopPaddingFromTags = 0;
    this.filteredListWithCategory = [];
    this.isListWithCategoryFirst = false;
    this.svgIcons = new SvgIcons(this.sanitizer);
    this.onChangedCallback = _ => {}; // eslint-disable-line @typescript-eslint/no-unused-vars
    this.onTouchedCallback = _ => {}; // eslint-disable-line @typescript-eslint/no-unused-vars
    this._filteredList = [];
    this.icons.arrow = this.svgIcons.getSvgIcons('icon-arrow-down');
    this.icons.close = this.svgIcons.getSvgIcons('icon-close');
    this.icons.search = this.svgIcons.getSvgIcons('icon-search2');
  }
  get filteredList() {
    return this._filteredList;
  }
  set filteredList(value) {
    const dividedData = this.divideListCategoryBased(value, this.maxItemsToDisplay, this.enableInfiniteScroll);
    this.filteredListWithCategory = dividedData.filteredListWithCategory;
    this.isListWithCategoryFirst = dividedData.isListWithCategoryFirst;
    this._filteredList = dividedData.filteredList;
  }
  ngOnInit() {
    if (this.serverSideSearch !== undefined && this.serverSideSearch.enabled === true) {
      this.serverSideSearch.keyStrokeDelay = this.serverSideSearch.keyStrokeDelay === undefined ? this.defaultKeystrokedelay : this.serverSideSearch.keyStrokeDelay;
      this.serverSideSearch.resultsCount = this.serverSideSearch.resultsCount === undefined ? this.defaultResultscount : this.serverSideSearch.resultsCount;
    }
    this.loadDropdown();
    if (this.displayTags) {
      this.prepareSelectedTags();
    }
  }
  prepareSelectedTags() {
    this.selectedTags = [...this.selection];
  }
  ngOnChanges(changes) {
    if (changes.options && changes.options.currentValue && !changes.options.firstChange) {
      this.options = changes.options.currentValue;
      this.loadDropdown();
    }
    if (changes.selection) {
      if (changes.selection && changes.selection.currentValue && !changes.selection.firstChange) {
        this.selection = changes.selection.currentValue;
        this.loadDropdown();
      }
    }
  }
  writeValue(obj) {
    this.selection = obj;
  }
  registerOnChange(fn) {
    this.onChangedCallback = fn;
  }
  registerOnTouched(fn) {
    this.onTouchedCallback = fn;
  }
  setDisabledState(isDisabled) {
    this.disabled = isDisabled;
  }
  /* This function initialises the dropdown with the data */
  loadDropdown() {
    this.sortKey = this.sortKey ? this.sortKey : this.label;
    if (this.serverSideSearch !== undefined && this.serverSideSearch.enabled === true) {
      this.prepareOptionsWhenServerSearchEnabled();
    } else {
      this.prepareOptions();
      this.assignBorder();
    }
  }
  /* This function clears the search input field */
  clearQuery(event) {
    this.dropdownTouched = true;
    this.query = '';
    if (this.serverSideSearch !== undefined && this.serverSideSearch.enabled === true) {
      this.serverSearch('', this.selectAll, 0);
    } else {
      this.filteredList = [...this.options];
    }
    if (event) {
      event.stopPropagation();
    }
    this.cd.detectChanges();
  }
  /* This function handles the functionality when the dropdown is opened or closed */
  toggleDropdown() {
    this.animating = true;
    if (this.serverSideSearch === undefined) {
      this.clearQuery();
    }
    this.isDropdownOpen = !this.isDropdownOpen;
    if (this.isDropdownOpen) {
      this.loadDropdown();
      this.dropdownOpened.emit();
      this.focusOnInput();
    } else {
      this.dropdownTouched = true;
      this.dropdownClosed.emit();
    }
  }
  /* This function is used to filter search results when an item is search for in the dropdown */
  onSearch(event) {
    this.dropdownTouched = true;
    /* Whenever the user presses the escape key inside the search field, then the query is cleared.
        If the query is already cleared and the user presses the escape key, then the dropdown is toggled off */
    if (event.keyCode === 27 && this.query.length !== 0) {
      this.clearQuery();
      return;
    } else if (event.keyCode === 27 && this.query.length === 0) {
      this.toggleDropdown();
      return;
    }
    const searchQuery = event.target.value;
    if (this.serverSideSearch !== undefined && this.serverSideSearch.enabled === true) {
      this.serverSearch(searchQuery, this.selectAll, this.serverSideSearch.keyStrokeDelay);
    } else {
      setTimeout(() => {
        const searchResults = this.options.filter(item => {
          if (item[this.label].toLowerCase().includes(searchQuery.toLowerCase())) {
            return true;
          }
          return false;
        });
        this.filteredList = searchResults;
        this.cd.detectChanges();
      });
    }
  }
  addItemInList(item) {
    if (this.maxSelectionLimit !== undefined) {
      if (this.maxSelectionLimit >= this.selection.length) {
        this.selection.push({
          ...item
        });
      }
      if (this.maxSelectionLimit === this.selection.length) {
        this.isMaxItemsSelected = true;
      }
    } else {
      this.selection.push({
        ...item
      });
    }
  }
  deleteTag(item) {
    // Since the multiselect does not automatically updates when removing the element, we close the selection dropdown.
    if (this.isDropdownOpen) {
      this.toggleDropdown();
    }
    item.selected = false;
    const index = this.selection.findIndex(obj => obj[this.primaryKey] === item[this.primaryKey]);
    this.isMaxItemsSelected = false;
    this.selection.splice(index, 1);
    this.deselectedOptions.push(item);
    this.selectedTags = [...this.selection];
    this.updateTopPaddingOfDropdownFromTags();
    if (this.isRequired && this.selectedTags.length === 0) {
      this.dropdownTouched = true;
    }
    this.onChangedCallback(this.selection);
    this.selectionChanged.emit({
      selected: this.selection,
      deselected: this.selectAll ? this.deselectedOptions : [],
      selectAll: this.selectAll ? undefined : false
    });
  }
  /* This function handles the selection or deselection of items in the dropdown */
  toggleItem(item) {
    item.selected = !item.selected;
    this.dropdownTouched = true;
    const index = this.selection.findIndex(obj => obj[this.primaryKey] === item[this.primaryKey]);
    if (index === -1) {
      this.addItemInList(item);
      if (this.deselectedOptions.length !== 0) {
        const indexOfDeselectedList = this.deselectedOptions.findIndex(obj => obj[this.primaryKey] === item[this.primaryKey]);
        this.deselectedOptions.splice(indexOfDeselectedList, 1);
      }
    } else {
      this.isMaxItemsSelected = false;
      this.selection.splice(index, 1);
      this.deselectedOptions.push(item);
    }
    this.selectedTags = [...this.selection];
    this.updateTopPaddingOfDropdownFromTags();
    this.onChangedCallback(this.selection);
    this.selectionChanged.emit({
      selected: this.selection,
      deselected: this.selectAll ? this.deselectedOptions : [],
      selectAll: this.selectAll ? undefined : false
    });
  }
  /* This function handles the select all bulk operation behaviour */
  onSelectAll() {
    this.dropdownTouched = true;
    this.selectAll = true;
    this.deselectedOptions.splice(0, this.deselectedOptions.length);
    setTimeout(() => {
      this.options.forEach(item => {
        item.selected = true;
        delete item.border;
      });
      this.selection = [...this.options];
      this.selectedTags = [...this.selection];
      this.updateTopPaddingOfDropdownFromTags();
      this.onChangedCallback(this.selection);
      this.selectionChanged.emit({
        selected: this.selection,
        deselected: this.deselectedOptions,
        selectAll: this.selectAll
      });
    });
  }
  /* This function handles the clear all bulk operation behaviour */
  onClearAll() {
    this.dropdownTouched = true;
    this.selectAll = false;
    this.deselectedOptions = [...this.selection];
    this.selection = [];
    this.selectedTags = [];
    this.updateTopPaddingOfDropdownFromTags();
    setTimeout(() => {
      this.options.forEach(item => {
        item.selected = false;
        delete item.border;
      });
      this.onChangedCallback(this.selection);
      this.selectionChanged.emit({
        selected: this.selection,
        deselected: this.deselectedOptions,
        selectAll: this.selectAll
      });
    });
  }
  /**
   * Detect changes to get the latest height of the tags component after tags were updated. Than get the height
   * of the tags component plus additional 2 pixels to compensate for borders.
   */
  updateTopPaddingOfDropdownFromTags() {
    this.cd.detectChanges();
    this.dropdownTopPaddingFromTags = this.dropdownButtonEleRef.nativeElement.clientHeight + 2;
  }
  /* This function handles focus-out event */
  onTouched() {
    if (!this.dropdownTouched) {
      this.onTouchedCallback();
      this.dropdownTouched = true;
    }
  }
  /* This function validate modal state */
  validate(control) {
    return this.isRequired ? Validators.required(control) : null;
  }
  /* This function marks the selected items in the total list of options */
  prepareOptions() {
    this.options = this.options === undefined ? [] : [...this.options];
    this.selection = this.selection === undefined ? [] : [...this.selection];
    this.selection.forEach(item => item.selected = true);
    this.selectedTags = [...this.selection];
    this.options.forEach(item => {
      delete item.border;
      const index = this.selection.findIndex(selectedItem => selectedItem[this.primaryKey] === item[this.primaryKey]);
      item.selected = index === -1 ? false : true;
    });
    if (this.maxSelectionLimit <= this.selection.length) {
      this.isMaxItemsSelected = true;
    } else {
      this.isMaxItemsSelected = false;
    }
    this.options = this.sortOptions(this.options);
  }
  /* This function marks the selected items in the total list of options when server search is enabled*/
  prepareOptionsWhenServerSearchEnabled() {
    const displayedOptions = [];
    this.options = this.options === undefined ? [] : [...this.options];
    this.selection = this.selection === undefined ? [] : [...this.selection];
    this.addSelectedItemsInDisplayedOptions(this.selection, displayedOptions);
    this.addUnSelectedItemsInDisplayedOptions(this.options, displayedOptions);
    this.markSelection(displayedOptions);
    this.filteredList = [...displayedOptions];
    this.filteredList = this.sortOptions(this.filteredList);
    this.assignBorderWhenServerSearchEnabled(this.filteredList);
  }
  addSelectedItemsInDisplayedOptions(selectedItems, displayedOptions) {
    selectedItems.forEach(item => {
      delete item.border;
      item.selected = true;
    });
    if (!this.selectAll && this.isEmpty(this.query)) {
      selectedItems.forEach(item => {
        displayedOptions.push(item);
      });
    }
  }
  addUnSelectedItemsInDisplayedOptions(options, displayedOptions) {
    let counter = displayedOptions.length;
    options.forEach(item => {
      if (counter < this.maxItemsToDisplay) {
        delete item.border;
        const index = displayedOptions.findIndex(selectedItem => selectedItem[this.primaryKey] === item[this.primaryKey]);
        item.selected = index === -1 ? false : true;
        if (!item.selected) {
          displayedOptions.push(item);
          counter = counter + 1;
        }
      }
    });
  }
  markSelection(displayedOptions) {
    if (this.selectAll || !this.isEmpty(this.query)) {
      displayedOptions.forEach(item => {
        if (this.selection.findIndex(obj => obj[this.primaryKey] === item[this.primaryKey]) !== -1) {
          item.selected = true;
        }
      });
    }
  }
  isEmpty(value) {
    return value === '' || value === undefined || value === null;
  }
  /*This function is responsible for searching query on server side based on keystroke delay*/
  serverSearch(query, selectAll, timeout) {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
    this.timer = setTimeout(() => {
      this.onServerSideSearch.emit({
        offset: 0,
        searchQuery: query,
        selectAll: selectAll
      });
    }, timeout);
  }
  /* This function assigns a border property to the first unselected item, so that we can show a border differentiating
  the selected items from the deselected items */
  assignBorder() {
    if (this.options.length > 0 && this.selection.length !== this.options.length && this.selection.length !== 0) {
      this.options[this.selection.length - 1].border = true;
    }
    this.filteredList = [...this.options];
  }
  /* This function assigns a border property to the first unselected item if no query present in search box,
   while opening a drop-down again */
  assignBorderWhenServerSearchEnabled(list) {
    if (this.isEmpty(this.query) && this.selection.length < list.length && this.selection.length !== 0) {
      list[this.selection.length - 1].border = true;
    }
  }
  /* This function is responsible for sorting the list of options based on the inputs */
  sortOptions(options) {
    options.sort((a, b) => {
      if (a.selected && !b.selected) {
        return -1;
      } else if (!a.selected && b.selected) {
        return 1;
      } else if (this.sortOrder === 'asc') {
        return a[this.sortKey].localeCompare(b[this.sortKey]);
      } else if (this.sortOrder === 'desc') {
        return b[this.sortKey].localeCompare(a[this.sortKey]);
      } else if (this.sortOrder === 'unsort') {
        return 0;
      } else {
        return 0;
      }
    });
    return [...options];
  }
  /* This function focuses the cursor on the search input box */
  focusOnInput() {
    if (this.inputElRef) {
      this.inputElRef.nativeElement.querySelector('input[type="text"]').focus();
    }
  }
  /* This function returns the primary index of each object in the collection.
   This is done to better index and uniquely identify the options in the dropdown  */
  trackByFn() {
    return this.primaryKey;
  }
  /* This function closes the dropdown whenever there is a click outside the dropdown area */
  closeDropdown(event) {
    if (!this.dropdownElRef.nativeElement.contains(event.target) && this.isDropdownOpen) {
      this.toggleDropdown();
    }
  }
  closeDropdownOnShowMoreClicked() {
    if (this.isDropdownOpen) {
      this.toggleDropdown();
    }
  }
  /* Method which is executed whenever a toggle animation is complete */
  onToggleDone(_event) {
    this.animating = false;
  }
  /* returns the placeholder content */
  getPlaceholder() {
    if (this.selection && this.selection.length === 0 || this.selection === null) {
      return this.placeholder;
    } else {
      return this.formattedPlaceholder;
    }
  }
  /* returns the placeholder content for aria label */
  getAriaLabel() {
    if (this.selection && this.selection.length === 0 || this.selection === null) {
      return this.placeholder;
    } else {
      return this.formattedAriaLabel;
    }
  }
  /* prepares the placeholder dynamically based on the available container width */
  prepareFormattedPlaceholder(items, containerWidth) {
    this.showCount = false;
    let remainingWidth = containerWidth;
    const placeholderItems = [];
    const offset = 10;
    for (const item of items) {
      if (remainingWidth - item.width - offset > 0) {
        remainingWidth = remainingWidth - item.width - offset;
        placeholderItems.push(item.text);
      } else {
        this.showCount = true;
        break;
      }
    }
    if (this.selectAll === true && this.serverSideSearch !== undefined && this.serverSideSearch.enabled === true && this.deselectedOptions.length === 0) {
      items.length = this.serverSideSearch.resultsCount;
    }
    this.formattedPlaceholder = this.showCount ? this.translate.transform('cxone-components.dropdowns.buttonPlaceholderFormat', {
      count: items.length
    }) : placeholderItems.join(', ');
  }
  /* prepares the placeholder dynamically based on the available container width */
  prepareAriaLabel(items, containerWidth) {
    this.showCount = false;
    let remainingWidth = containerWidth;
    const placeholderItems = [];
    const offset = 10;
    for (const item of items) {
      if (remainingWidth - item.width - offset > 0) {
        remainingWidth = remainingWidth - item.width - offset;
        placeholderItems.push(item.text);
      } else {
        this.showCount = true;
        break;
      }
    }
    if (this.selectAll === true && this.serverSideSearch !== undefined && this.serverSideSearch.enabled === true && this.deselectedOptions.length === 0) {
      items.length = this.serverSideSearch.resultsCount;
    }
    this.formattedAriaLabel = this.showCount ? this.translate.transform('cxone-components.dropdowns.buttonPlaceholderFormat', {
      count: items.length
    }) : this.translate.transform('cxone-components.dropdowns.buttonAriaLabel').concat(placeholderItems.join(', '));
  }
  ngAfterViewInit() {
    this.invisibleItemsRef.changes.subscribe(() => {
      if (this.placeholderElRef !== undefined && this.invisibleItemsRef.toArray().length !== 0) {
        const containerWidth = this.placeholderElRef.nativeElement.offsetWidth;
        const items = this.invisibleItemsRef.toArray().map(x => {
          return {
            width: x.nativeElement.offsetWidth,
            text: x.nativeElement.textContent
          };
        });
        this.prepareAriaLabel(items, containerWidth);
        this.prepareFormattedPlaceholder(items, containerWidth);
        this.cd.detectChanges();
      }
    });
    this.dropdownTopPaddingFromTags = this.dropdownButtonEleRef.nativeElement.clientHeight + 2;
  }
  loadMoreData() {
    if (this.enableInfiniteScroll) {
      this.onLoadData.emit();
    }
  }
  onScroll() {
    this.scroll.emit();
  }
  onTagsSearchClick(clickEvent) {
    if (this.isDropdownOpen) {
      clickEvent.stopPropagation();
    }
  }
  /* this function divide list of options to 2 array: with selected + no-category and with category. */
  /* Return both arrays and isListWithCategoryFirst */
  divideListCategoryBased(list, maxItemsToDisplay, enableInfiniteScroll) {
    // limitation: categories disabled for infiniteScroll
    if (enableInfiniteScroll) {
      return {
        filteredList: list,
        filteredListWithCategory: [],
        isListWithCategoryFirst: false
      };
    }
    const newFilteredList = [];
    const newCategoryList = [];
    let isListWithCategoryFirst = true;
    for (const item of list) {
      if (item.selected || !item.category) {
        newFilteredList.push(item);
        isListWithCategoryFirst = false;
      } else {
        const index = newCategoryList.findIndex(el => el.name === item.category);
        if (index !== -1) {
          newCategoryList[index].items.push(item);
        } else {
          newCategoryList.push({
            name: item.category,
            items: [item]
          });
        }
      }
    }
    let categoryListToDisplay = newCategoryList;
    // limit categoryListToDisplay depends on maxItemsToDisplay. To not show redundant items in html render
    if (list.length > maxItemsToDisplay) {
      categoryListToDisplay = [];
      if (newFilteredList.length < maxItemsToDisplay) {
        let categoryItemsLeft = maxItemsToDisplay - newFilteredList.length;
        categoryListToDisplay = [];
        for (const item of newCategoryList) {
          if (item.items.length <= categoryItemsLeft) {
            categoryListToDisplay.push(item);
          } else {
            categoryListToDisplay.push({
              name: item.name,
              items: item.items.slice(0, categoryItemsLeft)
            });
          }
          categoryItemsLeft -= item.items.length;
          if (categoryItemsLeft <= 0) {
            break;
          }
        }
      }
    }
    return {
      filteredList: newFilteredList,
      filteredListWithCategory: categoryListToDisplay,
      isListWithCategoryFirst
    };
  }
  /** @nocollapse */
  static {
    this.ɵfac = function MultiselectDropdownComponent_Factory(t) {
      return new (t || MultiselectDropdownComponent)(i0.ɵɵdirectiveInject(i1$1.DomSanitizer), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.TranslationPipe));
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: MultiselectDropdownComponent,
      selectors: [["cxone-multiselect-dropdown"]],
      viewQuery: function MultiselectDropdownComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c3, 5);
          i0.ɵɵviewQuery(_c4, 5);
          i0.ɵɵviewQuery(_c5, 5);
          i0.ɵɵviewQuery(_c6, 5, ElementRef);
          i0.ɵɵviewQuery(_c7, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdownElRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dropdownButtonEleRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.placeholderElRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputElRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.invisibleItemsRef = _t);
        }
      },
      hostBindings: function MultiselectDropdownComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("click", function MultiselectDropdownComponent_click_HostBindingHandler($event) {
            return ctx.closeDropdown($event);
          }, false, i0.ɵɵresolveDocument);
        }
      },
      inputs: {
        bulkOperations: "bulkOperations",
        isLoading: "isLoading",
        isRequired: "isRequired",
        label: "label",
        maxItemsToDisplay: "maxItemsToDisplay",
        options: "options",
        placeholder: "placeholder",
        primaryKey: "primaryKey",
        search: "search",
        sortKey: "sortKey",
        sortOrder: "sortOrder",
        showFooter: "showFooter",
        template: "template",
        maxSelectionLimit: "maxSelectionLimit",
        serverSideSearch: "serverSideSearch",
        enableInfiniteScroll: "enableInfiniteScroll",
        displayTags: "displayTags",
        maxTagsToDisplay: "maxTagsToDisplay",
        tagsHeaderTemplate: "tagsHeaderTemplate",
        selection: "selection"
      },
      outputs: {
        dropdownOpened: "dropdownOpened",
        dropdownClosed: "dropdownClosed",
        selectionChanged: "selectionChanged",
        onServerSideSearch: "onServerSideSearch",
        onLoadData: "onLoadData",
        scroll: "scroll"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => MultiselectDropdownComponent),
        multi: true
      }, {
        provide: NG_VALIDATORS,
        useExisting: MultiselectDropdownComponent,
        multi: true
      }]), i0.ɵɵNgOnChangesFeature],
      decls: 9,
      vars: 14,
      consts: [["tabindex", "0", 1, "cxone-multiselect-dropdown", 3, "ngClass", "focusout"], ["dropdownElement", ""], ["role", "button", 1, "dropdown-button", 3, "ngClass", "keydown.enter", "click"], ["dropdownButton", ""], [4, "ngIf"], ["class", "dropdown-popover-wrapper", 3, "ngStyle", 4, "ngIf"], ["searchTemplate", ""], [3, "tagsHeaderTemplate", "maxTagsToDisplay", "removable", "tagsSource", "primaryKey", "label", "click", "viewMoreClicked", "tagDeleted"], [4, "ngTemplateOutlet"], [1, "button-text"], ["placeholderEl", ""], [1, "button-text", "invisible"], [4, "ngFor", "ngForOf"], ["role", "image", 1, "icon-carat", 3, "ngClass", "innerHTML"], ["invisibleItem", ""], [1, "dropdown-popover-wrapper", 3, "ngStyle"], ["class", "bulk-operations-wrapper", 4, "ngIf"], ["class", "options-wrapper", "cxoneInfiniteScrolling", "", 3, "scrollEvent", "endScroll", 4, "ngIf"], ["class", "loading-wrapper", 4, "ngIf"], ["class", "no-results-wrapper", 4, "ngIf"], ["class", "count-wrapper", 4, "ngIf"], [1, "bulk-operations-wrapper"], ["tabindex", "1", "role", "button", 1, "select-all-btn", 3, "ngClass", "click", "keydown.enter"], ["tabindex", "1", "role", "button", 1, "clear-all-btn", 3, "ngClass", "click", "keydown.enter"], ["cxoneInfiniteScrolling", "", 1, "options-wrapper", 3, "scrollEvent", "endScroll"], ["class", "cxone-multiselect-dropdown-item", 3, "item", "query", "maxSelectionLimit", "isMaxItemsSelected", "label", "template", "isFirst", "isSelected", "toggleItem", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "cxone-multiselect-dropdown-item", 3, "item", "query", "maxSelectionLimit", "isMaxItemsSelected", "label", "template", "isFirst", "isSelected", "toggleItem"], [1, "dropdown-category"], ["cxoneOverflowTooltip", "", 1, "dropdown-category-text", 3, "tooltipPlacement", "tooltipContent"], ["tooltipTemplate", ""], [3, "innerHTML"], [1, "loading-wrapper"], [3, "isSpinner"], [1, "no-results-wrapper"], [1, "no-results-text"], [1, "count-wrapper"], [1, "count-display"], [1, "count-value"], ["class", "search-wrapper", 3, "click", 4, "ngIf"], ["class", "search-wrapper", 4, "ngIf"], [1, "search-wrapper", 3, "click"], ["tabindex", "1", "accessLabel", "Search", 1, "search-box", 3, "ngModel", "accessLabel", "placeholder", "ngModelChange", "keyup"], ["inputEl", ""], ["class", "icon-close", "tabindex", "1", "role", "button", 3, "innerHTML", "keydown.enter", "click", 4, "ngIf"], ["class", "icon-search", "role", "button", 3, "innerHTML", 4, "ngIf"], ["tabindex", "1", "role", "button", 1, "icon-close", 3, "innerHTML", "keydown.enter", "click"], ["role", "button", 1, "icon-search", 3, "innerHTML"], [1, "search-wrapper"], [1, "search-box", 3, "ngModel", "accessLabel", "placeholder", "ngModelChange", "keyup"], ["class", "icon-close", "tabindex", "1", 3, "innerHTML", "keydown.enter", "click", 4, "ngIf"], ["tabindex", "1", 1, "icon-close", 3, "innerHTML", "keydown.enter", "click"]],
      template: function MultiselectDropdownComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0, 1);
          i0.ɵɵlistener("focusout", function MultiselectDropdownComponent_Template_div_focusout_0_listener() {
            return ctx.onTouched();
          });
          i0.ɵɵelementStart(2, "div", 2, 3);
          i0.ɵɵlistener("keydown.enter", function MultiselectDropdownComponent_Template_div_keydown_enter_2_listener() {
            return ctx.toggleDropdown();
          })("click", function MultiselectDropdownComponent_Template_div_click_2_listener() {
            return ctx.toggleDropdown();
          });
          i0.ɵɵtemplate(4, MultiselectDropdownComponent_ng_container_4_Template, 3, 7, "ng-container", 4)(5, MultiselectDropdownComponent_ng_container_5_Template, 7, 7, "ng-container", 4);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(6, MultiselectDropdownComponent_div_6_Template, 8, 10, "div", 5);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(7, MultiselectDropdownComponent_ng_template_7_Template, 2, 2, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c11, ctx.isDropdownOpen));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(10, _c12, ctx.disabled === true, ctx.dropdownTouched === true && ctx.isRequired === true && ctx.selection.length === 0, ctx.displayTags));
          i0.ɵɵattribute("aria-label", ctx.getAriaLabel())("aria-expanded", ctx.isDropdownOpen)("tabindex", ctx.disabled !== true ? 1 : -1);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.displayTags);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.displayTags);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.isDropdownOpen);
        }
      },
      dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgTemplateOutlet, i3.NgStyle, i3$1.NgControlStatus, i3$1.NgModel, i5.SpinnerComponent, i6.TextInputComponent, i4.OverflowTooltipDirective, i8.InfiniteScrollingDirective, i9.SelectedTagsComponent, MultiselectDropdownItemComponent, i3.SlicePipe, i2.TranslationPipe, HighlightPipe],
      styles: [".tooltip{z-index:10000}.tooltip .highlighted{font-weight:bolder}.cxone-multiselect-dropdown{position:relative;width:100%;font-family:OpenSans}.cxone-multiselect-dropdown.expanded{box-shadow:0 2px 6px #00000017}.cxone-multiselect-dropdown.expanded .dropdown-popover-wrapper{border-bottom:1px solid rgb(208,210,211);box-shadow:0 2px 6px #00000017}.cxone-multiselect-dropdown .dropdown-button{display:flex;height:35px;border:1px solid rgb(208,210,211);background-color:#fff;align-items:center;cursor:pointer;-webkit-user-select:none;user-select:none}.cxone-multiselect-dropdown .dropdown-button.custom-max-tags{height:100%;flex-wrap:wrap}.cxone-multiselect-dropdown .dropdown-button cxone-selected-tags .cxone-selected-tags{min-width:0}.cxone-multiselect-dropdown .dropdown-button .search-wrapper{position:relative;padding-bottom:0}.cxone-multiselect-dropdown .dropdown-button .search-wrapper .cxone-text-input input[type=text]{height:30px;border:none;outline:none}.cxone-multiselect-dropdown .dropdown-button .search-wrapper i{position:absolute;right:0;top:0;cursor:pointer}.cxone-multiselect-dropdown .dropdown-button .search-wrapper i svg{display:none}.cxone-multiselect-dropdown .dropdown-button.required{border:1px solid rgb(217,33,51)}.cxone-multiselect-dropdown .dropdown-button.disabled{background:#f8f8f8 0% 0% no-repeat padding-box!important;border:1px solid rgb(208,210,211)!important;opacity:1;pointer-events:none}.cxone-multiselect-dropdown .dropdown-button.disabled .button-text{color:#707e8d!important}.cxone-multiselect-dropdown .dropdown-button.disabled svg{fill:#adadad!important}.cxone-multiselect-dropdown .dropdown-button:hover:not(.required){border-color:#007cbe}.cxone-multiselect-dropdown .dropdown-button .button-text{flex:1;font-size:13px;padding:9px 15px;color:#2e2e2e;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cxone-multiselect-dropdown .dropdown-button .button-text.invisible{visibility:hidden;position:absolute;overflow:hidden;width:0;padding:0;height:0}.cxone-multiselect-dropdown .dropdown-button .icon-carat{flex-grow:0;flex-shrink:0;transform:scale(.4)}.cxone-multiselect-dropdown .dropdown-button .icon-carat svg{fill:#007cbe;position:relative;top:3px;transition:.2s;width:32px;height:32px}.cxone-multiselect-dropdown .dropdown-button .icon-carat.dropdown-open svg{transform:rotate(180deg);transition:.2s}.cxone-multiselect-dropdown .dropdown-button .icon-carat.dropdown-closed svg{transform:rotate(0);transition:.2s}.cxone-multiselect-dropdown .dropdown-popover-wrapper{position:absolute;top:35px;display:flex;flex-direction:column;background:#fff;border-left:1px solid rgb(208,210,211);border-right:1px solid rgb(208,210,211);border-top:none;width:100%;z-index:9999;overflow:hidden}.cxone-multiselect-dropdown .dropdown-popover-wrapper .search-wrapper{position:relative;padding:10px 11px 0}.cxone-multiselect-dropdown .dropdown-popover-wrapper .search-wrapper .cxone-text-input input[type=text]{height:30px;padding-left:6px;padding-right:30px;border:1px solid rgb(208,210,211)}.cxone-multiselect-dropdown .dropdown-popover-wrapper .search-wrapper i{position:absolute;right:0;top:0;cursor:pointer}.cxone-multiselect-dropdown .dropdown-popover-wrapper .search-wrapper i svg{fill:#526b7a;opacity:.8;transform:scale(.5);position:relative;top:10px;right:14px;width:32px;height:32px}.cxone-multiselect-dropdown .dropdown-popover-wrapper .bulk-operations-wrapper{display:flex;color:#007cbe;padding:10px 12px 0;font-size:12px}.cxone-multiselect-dropdown .dropdown-popover-wrapper .bulk-operations-wrapper span{margin-right:19px;cursor:pointer}.cxone-multiselect-dropdown .dropdown-popover-wrapper .bulk-operations-wrapper span:hover{text-decoration:underline}.cxone-multiselect-dropdown .dropdown-popover-wrapper .bulk-operations-wrapper span.disabled{color:#adadad;pointer-events:none}.cxone-multiselect-dropdown .dropdown-popover-wrapper .options-wrapper{padding:2px 12px 0;max-height:210px;overflow-y:auto;overflow-x:hidden}.cxone-multiselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row{display:flex;align-items:center;cursor:pointer;min-height:35px;line-height:14px}.cxone-multiselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row .cxone-checkbox{line-height:25px}.cxone-multiselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row.border{border-bottom:1px solid rgb(208,210,211)}.cxone-multiselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row.disabled{color:#707e8d;pointer-events:none}.cxone-multiselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row .item-text{flex-grow:0;flex-shrink:0;color:#2e2e2e;font-size:13px;-webkit-user-select:none;user-select:none;width:85%;min-height:16px;max-height:32px;position:relative;top:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;-webkit-box-orient:vertical;-webkit-line-clamp:2}.cxone-multiselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row .highlighted{font-weight:bolder}.cxone-multiselect-dropdown .dropdown-popover-wrapper .options-wrapper .dropdown-category{display:flex;align-items:center;height:35px}.cxone-multiselect-dropdown .dropdown-popover-wrapper .options-wrapper .dropdown-category-text{font-size:13px;color:#2e2e2e;line-height:16px;font-weight:700;overflow:hidden;white-space:nowrap;position:relative;text-overflow:ellipsis}.cxone-multiselect-dropdown .dropdown-popover-wrapper .no-results-wrapper{display:flex;padding-left:11px;height:35px;align-items:center}.cxone-multiselect-dropdown .dropdown-popover-wrapper .no-results-wrapper .no-results-text{font-size:13px;color:#707e8d}.cxone-multiselect-dropdown .dropdown-popover-wrapper .loading-wrapper{position:relative;padding:30px 0 30px 95px}.cxone-multiselect-dropdown .dropdown-popover-wrapper .loading-wrapper .p-i-icon{display:flex}.cxone-multiselect-dropdown .dropdown-popover-wrapper .count-wrapper{padding:2px 18px 2px 12px;height:35px}.cxone-multiselect-dropdown .dropdown-popover-wrapper .count-wrapper .count-display{border-top:1px solid rgb(208,210,211);font-size:12px}.cxone-multiselect-dropdown .dropdown-popover-wrapper .count-wrapper .count-display div.count-value{color:#526b7a;position:relative;height:31px;display:flex;align-items:center}.cxone-multiselect-dropdown .dropdown-popover-wrapper .count-wrapper .count-display div.count-value .total-count{padding-left:3px}\n"],
      encapsulation: 2,
      data: {
        animation: [trigger('dropdownContent', [state('hidden', style({
          height: '0'
        })), state('void', style({
          height: '{{ height }}'
        }), {
          params: {
            height: '0'
          }
        }), state('visible', style({
          height: '*'
        })), transition('visible <=> hidden', animate('{{ transitionParams }}')), transition('void <=> hidden', animate('{{ transitionParams }}')), transition('void <=> visible', animate('{{ transitionParams }}'))])]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiselectDropdownComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-multiselect-dropdown',
      encapsulation: ViewEncapsulation.None,
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => MultiselectDropdownComponent),
        multi: true
      }, {
        provide: NG_VALIDATORS,
        useExisting: MultiselectDropdownComponent,
        multi: true
      }],
      animations: [trigger('dropdownContent', [state('hidden', style({
        height: '0'
      })), state('void', style({
        height: '{{ height }}'
      }), {
        params: {
          height: '0'
        }
      }), state('visible', style({
        height: '*'
      })), transition('visible <=> hidden', animate('{{ transitionParams }}')), transition('void <=> hidden', animate('{{ transitionParams }}')), transition('void <=> visible', animate('{{ transitionParams }}'))])],
      template: "<div class=\"cxone-multiselect-dropdown\"  tabindex=\"0\" #dropdownElement (focusout)=\"onTouched()\" [ngClass]=\"{ 'expanded': isDropdownOpen }\">\n  <div class=\"dropdown-button\" #dropdownButton role=\"button\" [attr.aria-label]=\"getAriaLabel()\" [attr.aria-expanded]=\"isDropdownOpen\"\n       [attr.tabindex]=\"disabled !== true?1:-1\" (keydown.enter)=\"toggleDropdown()\" (click)=\"toggleDropdown()\"\n       [ngClass]=\"{ 'disabled': disabled === true, 'required': dropdownTouched === true && isRequired === true && selection.length === 0, 'custom-max-tags': displayTags }\">\n    <!-- With Tags -->\n    <ng-container *ngIf=\"displayTags\">\n      <cxone-selected-tags (click)=\"$event.stopPropagation()\"\n                           [tagsHeaderTemplate]=\"tagsHeaderTemplate\"\n                           [maxTagsToDisplay]=\"maxTagsToDisplay\" [removable]=\"true\"\n                           [tagsSource]=\"selectedTags\" [primaryKey]=\"primaryKey\" [label]=\"label\"\n                           (viewMoreClicked)=\"closeDropdownOnShowMoreClicked()\"\n                           (tagDeleted)=\"deleteTag($event)\">\n      </cxone-selected-tags>\n      <ng-container *ngTemplateOutlet=\"searchTemplate\"></ng-container>\n    </ng-container>\n\n    <!-- Without Tags -->\n    <ng-container *ngIf=\"!displayTags\">\n      <div class=\"button-text\" #placeholderEl>{{ getPlaceholder() }}</div>\n      <div class=\"button-text invisible\"><span *ngFor=\"let item of selection\" #invisibleItem>{{ item[label] }}</span>\n      </div>\n      <i class=\"icon-carat\" role=\"image\"\n         [ngClass]=\"{'dropdown-open': isDropdownOpen, 'dropdown-closed': !isDropdownOpen}\"\n         [innerHTML]=\"icons.arrow\">\n      </i>\n    </ng-container>\n  </div>\n\n\n  <div class=\"dropdown-popover-wrapper\" *ngIf=\"isDropdownOpen\"\n       [ngStyle]=\"{'top': dropdownTopPaddingFromTags + 'px'}\">\n    <ng-container *ngIf=\"!displayTags\">\n      <ng-container *ngTemplateOutlet=\"searchTemplate\"></ng-container>\n    </ng-container>\n\n    <div class=\"bulk-operations-wrapper\"\n      *ngIf=\"bulkOperations && query.length === 0 && !isLoading && !maxSelectionLimit\">\n      <span class=\"select-all-btn\" (click)=\"onSelectAll()\" (keydown.enter)=\"onSelectAll()\" tabindex=\"1\"\n        [ngClass]=\"{ 'disabled': selection.length === options.length }\" role=\"button\" [attr.aria-label]=\"'cxone-components.dropdowns.selectall' | translate\" >{{ 'cxone-components.dropdowns.selectall' | translate }}</span>\n      <span class=\"clear-all-btn\" (click)=\"onClearAll()\" (keydown.enter)=\"onClearAll()\" tabindex=\"1\" role=\"button\" [attr.aria-label]=\"'cxone-components.dropdowns.clearall' | translate\"\n        [ngClass]=\"{ 'disabled': selection.length === 0 }\">{{ 'cxone-components.dropdowns.clearall' | translate }}</span>\n    </div>\n    <div class=\"options-wrapper\" *ngIf=\"!isLoading\" cxoneInfiniteScrolling (scrollEvent)=\"onScroll()\" (endScroll)=\"loadMoreData()\">\n      <cxone-multiselect-dropdown-item\n        class=\"cxone-multiselect-dropdown-item\" *ngFor=\"let item of filteredList | slice:0:maxItemsToDisplay; trackBy: trackByFn; first as isFirst\"\n        [item] = item\n        [query] = query\n        [maxSelectionLimit] = maxSelectionLimit\n        [isMaxItemsSelected] = isMaxItemsSelected\n        [label] = label\n        [template] = template\n        [isFirst] = isFirst\n        [isSelected] = item.selected\n        (toggleItem) = toggleItem($event);\n      >\n      </cxone-multiselect-dropdown-item>\n      <div *ngFor=\"let category of filteredListWithCategory; first as isFirstCategory\">\n        <div class=\"dropdown-category\">\n          <span\n            class=\"dropdown-category-text\"\n            cxoneOverflowTooltip\n            [tooltipPlacement]=\"isFirstCategory && isListWithCategoryFirst ? 'bottom' : 'top'\"\n            [tooltipContent]=\"tooltipTemplate\"\n          >{{category.name}}</span>\n        </div>\n        <ng-template #tooltipTemplate><span [innerHTML]=\"category.name|highlight:query\"></span></ng-template>\n        <cxone-multiselect-dropdown-item\n          class=\"cxone-multiselect-dropdown-item\" *ngFor=\"let item of category.items | slice:0:maxItemsToDisplay; trackBy: trackByFn; first as isFirst\"\n          [item] = item\n          [query] = query\n          [maxSelectionLimit] = maxSelectionLimit\n          [isMaxItemsSelected] = isMaxItemsSelected\n          [label] = label\n          [template] = template\n          [isFirst] = false\n          [isSelected] = item.selected\n          (toggleItem) = toggleItem($event);\n        >\n        </cxone-multiselect-dropdown-item>\n      </div>\n    </div>\n    <div class=\"loading-wrapper\" *ngIf=\"isLoading\">\n      <cxone-spinner [isSpinner]=\"isLoading\"></cxone-spinner>\n    </div>\n    <div class=\"no-results-wrapper\" *ngIf=\"query.length !== 0 && filteredList.length === 0 && filteredListWithCategory.length === 0\">\n      <span class=\"no-results-text\">{{ 'cxone-components.dropdowns.noresults' | translate }}</span>\n    </div>\n    <div class=\"count-wrapper\" *ngIf=\"query.length === 0 && isLoading === false && serverSideSearch === undefined && showFooter\">\n      <div class=\"count-display\">\n        <div class=\"count-value\">\n          {{ 'cxone-components.dropdowns.footerText' | translate:{ count: (options.length > maxItemsToDisplay) ? maxItemsToDisplay : options.length, total: options.length } }}\n        </div>\n      </div>\n    </div>\n    <div class=\"count-wrapper\"\n         *ngIf=\"serverSideSearch !== undefined && serverSideSearch.enabled === true && isLoading === false && showFooter\">\n      <div class=\"count-display\">\n        <div class=\"count-value\">\n          {{ 'cxone-components.dropdowns.footerText' | translate:{\n          count: (options.length > maxItemsToDisplay) ? maxItemsToDisplay : options.length,\n          total: serverSideSearch.resultsCount\n        } }}\n        </div>\n      </div>\n    </div>\n  </div>\n</div>\n\n<ng-template #searchTemplate>\n  <div class=\"search-wrapper\" *ngIf=\"!isLoading && search && serverSideSearch === undefined\" (click)=\"onTagsSearchClick($event)\">\n    <cxone-text-input class=\"search-box\" [(ngModel)]=\"query\"\n                      [accessLabel]=\"'cxone-components.dropdowns.searchingFor' | translate\" tabindex=\"1\"\n                      placeholder=\"{{ 'cxone-components.dropdowns.search' | translate }}\"\n                      accessLabel=\"Search\"\n                      (keyup)=\"onSearch($event)\" #inputEl>\n    </cxone-text-input>\n    <i class=\"icon-close\" *ngIf=\"query && query.length > 0\" tabindex=\"1\"\n       (keydown.enter)=\"clearQuery($event); loadDropdown()\" (click)=\"clearQuery($event); loadDropdown()\" role=\"button\"\n       [attr.aria-label]=\"'cxone-components.dropdowns.clearQuery' | translate\"\n       [innerHTML]=\"icons.close\">\n    </i>\n    <i class=\"icon-search\" *ngIf=\"query.length === 0\" [innerHTML]=\"icons.search\" role=\"button\"\n       [attr.aria-label]=\"'cxone-components.dropdowns.searchQuery' | translate\">\n    </i>\n  </div>\n\n  <div class=\"search-wrapper\" *ngIf=\"search && serverSideSearch !== undefined && serverSideSearch.enabled === true\">\n    <cxone-text-input class=\"search-box\" [(ngModel)]=\"query\" [accessLabel]=\"'Search'\"\n                      placeholder=\"{{ 'cxone-components.dropdowns.search' | translate }}\" (keyup)=\"onSearch($event)\" #inputEl>\n    </cxone-text-input>\n    <i class=\"icon-close\" *ngIf=\"query && query.length > 0\" (keydown.enter)=\"clearQuery($event); loadDropdown()\"\n       tabindex=\"1\" (click)=\"clearQuery($event); loadDropdown()\"\n       [innerHTML]=\"icons.close\">\n    </i>\n    <i class=\"icon-search\" *ngIf=\"query.length === 0\" [innerHTML]=\"icons.search\" role=\"button\"\n       [attr.aria-label]=\"'cxone-components.dropdowns.clearQuery' | translate\">\n    </i>\n  </div>\n</ng-template>\n",
      styles: [".tooltip{z-index:10000}.tooltip .highlighted{font-weight:bolder}.cxone-multiselect-dropdown{position:relative;width:100%;font-family:OpenSans}.cxone-multiselect-dropdown.expanded{box-shadow:0 2px 6px #00000017}.cxone-multiselect-dropdown.expanded .dropdown-popover-wrapper{border-bottom:1px solid rgb(208,210,211);box-shadow:0 2px 6px #00000017}.cxone-multiselect-dropdown .dropdown-button{display:flex;height:35px;border:1px solid rgb(208,210,211);background-color:#fff;align-items:center;cursor:pointer;-webkit-user-select:none;user-select:none}.cxone-multiselect-dropdown .dropdown-button.custom-max-tags{height:100%;flex-wrap:wrap}.cxone-multiselect-dropdown .dropdown-button cxone-selected-tags .cxone-selected-tags{min-width:0}.cxone-multiselect-dropdown .dropdown-button .search-wrapper{position:relative;padding-bottom:0}.cxone-multiselect-dropdown .dropdown-button .search-wrapper .cxone-text-input input[type=text]{height:30px;border:none;outline:none}.cxone-multiselect-dropdown .dropdown-button .search-wrapper i{position:absolute;right:0;top:0;cursor:pointer}.cxone-multiselect-dropdown .dropdown-button .search-wrapper i svg{display:none}.cxone-multiselect-dropdown .dropdown-button.required{border:1px solid rgb(217,33,51)}.cxone-multiselect-dropdown .dropdown-button.disabled{background:#f8f8f8 0% 0% no-repeat padding-box!important;border:1px solid rgb(208,210,211)!important;opacity:1;pointer-events:none}.cxone-multiselect-dropdown .dropdown-button.disabled .button-text{color:#707e8d!important}.cxone-multiselect-dropdown .dropdown-button.disabled svg{fill:#adadad!important}.cxone-multiselect-dropdown .dropdown-button:hover:not(.required){border-color:#007cbe}.cxone-multiselect-dropdown .dropdown-button .button-text{flex:1;font-size:13px;padding:9px 15px;color:#2e2e2e;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.cxone-multiselect-dropdown .dropdown-button .button-text.invisible{visibility:hidden;position:absolute;overflow:hidden;width:0;padding:0;height:0}.cxone-multiselect-dropdown .dropdown-button .icon-carat{flex-grow:0;flex-shrink:0;transform:scale(.4)}.cxone-multiselect-dropdown .dropdown-button .icon-carat svg{fill:#007cbe;position:relative;top:3px;transition:.2s;width:32px;height:32px}.cxone-multiselect-dropdown .dropdown-button .icon-carat.dropdown-open svg{transform:rotate(180deg);transition:.2s}.cxone-multiselect-dropdown .dropdown-button .icon-carat.dropdown-closed svg{transform:rotate(0);transition:.2s}.cxone-multiselect-dropdown .dropdown-popover-wrapper{position:absolute;top:35px;display:flex;flex-direction:column;background:#fff;border-left:1px solid rgb(208,210,211);border-right:1px solid rgb(208,210,211);border-top:none;width:100%;z-index:9999;overflow:hidden}.cxone-multiselect-dropdown .dropdown-popover-wrapper .search-wrapper{position:relative;padding:10px 11px 0}.cxone-multiselect-dropdown .dropdown-popover-wrapper .search-wrapper .cxone-text-input input[type=text]{height:30px;padding-left:6px;padding-right:30px;border:1px solid rgb(208,210,211)}.cxone-multiselect-dropdown .dropdown-popover-wrapper .search-wrapper i{position:absolute;right:0;top:0;cursor:pointer}.cxone-multiselect-dropdown .dropdown-popover-wrapper .search-wrapper i svg{fill:#526b7a;opacity:.8;transform:scale(.5);position:relative;top:10px;right:14px;width:32px;height:32px}.cxone-multiselect-dropdown .dropdown-popover-wrapper .bulk-operations-wrapper{display:flex;color:#007cbe;padding:10px 12px 0;font-size:12px}.cxone-multiselect-dropdown .dropdown-popover-wrapper .bulk-operations-wrapper span{margin-right:19px;cursor:pointer}.cxone-multiselect-dropdown .dropdown-popover-wrapper .bulk-operations-wrapper span:hover{text-decoration:underline}.cxone-multiselect-dropdown .dropdown-popover-wrapper .bulk-operations-wrapper span.disabled{color:#adadad;pointer-events:none}.cxone-multiselect-dropdown .dropdown-popover-wrapper .options-wrapper{padding:2px 12px 0;max-height:210px;overflow-y:auto;overflow-x:hidden}.cxone-multiselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row{display:flex;align-items:center;cursor:pointer;min-height:35px;line-height:14px}.cxone-multiselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row .cxone-checkbox{line-height:25px}.cxone-multiselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row.border{border-bottom:1px solid rgb(208,210,211)}.cxone-multiselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row.disabled{color:#707e8d;pointer-events:none}.cxone-multiselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row .item-text{flex-grow:0;flex-shrink:0;color:#2e2e2e;font-size:13px;-webkit-user-select:none;user-select:none;width:85%;min-height:16px;max-height:32px;position:relative;top:0;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;-webkit-box-orient:vertical;-webkit-line-clamp:2}.cxone-multiselect-dropdown .dropdown-popover-wrapper .options-wrapper .item-row .highlighted{font-weight:bolder}.cxone-multiselect-dropdown .dropdown-popover-wrapper .options-wrapper .dropdown-category{display:flex;align-items:center;height:35px}.cxone-multiselect-dropdown .dropdown-popover-wrapper .options-wrapper .dropdown-category-text{font-size:13px;color:#2e2e2e;line-height:16px;font-weight:700;overflow:hidden;white-space:nowrap;position:relative;text-overflow:ellipsis}.cxone-multiselect-dropdown .dropdown-popover-wrapper .no-results-wrapper{display:flex;padding-left:11px;height:35px;align-items:center}.cxone-multiselect-dropdown .dropdown-popover-wrapper .no-results-wrapper .no-results-text{font-size:13px;color:#707e8d}.cxone-multiselect-dropdown .dropdown-popover-wrapper .loading-wrapper{position:relative;padding:30px 0 30px 95px}.cxone-multiselect-dropdown .dropdown-popover-wrapper .loading-wrapper .p-i-icon{display:flex}.cxone-multiselect-dropdown .dropdown-popover-wrapper .count-wrapper{padding:2px 18px 2px 12px;height:35px}.cxone-multiselect-dropdown .dropdown-popover-wrapper .count-wrapper .count-display{border-top:1px solid rgb(208,210,211);font-size:12px}.cxone-multiselect-dropdown .dropdown-popover-wrapper .count-wrapper .count-display div.count-value{color:#526b7a;position:relative;height:31px;display:flex;align-items:center}.cxone-multiselect-dropdown .dropdown-popover-wrapper .count-wrapper .count-display div.count-value .total-count{padding-left:3px}\n"]
    }]
  }], () => [{
    type: i1$1.DomSanitizer
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i2.TranslationPipe
  }], {
    bulkOperations: [{
      type: Input
    }],
    isLoading: [{
      type: Input
    }],
    isRequired: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    maxItemsToDisplay: [{
      type: Input
    }],
    options: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    primaryKey: [{
      type: Input
    }],
    search: [{
      type: Input
    }],
    sortKey: [{
      type: Input
    }],
    sortOrder: [{
      type: Input
    }],
    showFooter: [{
      type: Input
    }],
    template: [{
      type: Input
    }],
    maxSelectionLimit: [{
      type: Input
    }],
    serverSideSearch: [{
      type: Input
    }],
    enableInfiniteScroll: [{
      type: Input
    }],
    displayTags: [{
      type: Input
    }],
    maxTagsToDisplay: [{
      type: Input
    }],
    tagsHeaderTemplate: [{
      type: Input
    }],
    selection: [{
      type: Input
    }],
    dropdownOpened: [{
      type: Output
    }],
    dropdownClosed: [{
      type: Output
    }],
    selectionChanged: [{
      type: Output
    }],
    onServerSideSearch: [{
      type: Output
    }],
    onLoadData: [{
      type: Output
    }],
    scroll: [{
      type: Output
    }],
    dropdownElRef: [{
      type: ViewChild,
      args: ['dropdownElement', {
        static: false
      }]
    }],
    dropdownButtonEleRef: [{
      type: ViewChild,
      args: ['dropdownButton', {
        static: false
      }]
    }],
    placeholderElRef: [{
      type: ViewChild,
      args: ['placeholderEl', {
        static: false
      }]
    }],
    invisibleItemsRef: [{
      type: ViewChildren,
      args: ['invisibleItem']
    }],
    inputElRef: [{
      type: ViewChild,
      args: ['inputEl', {
        static: false,
        read: ElementRef
      }]
    }],
    closeDropdown: [{
      type: HostListener,
      args: ['document:click', ['$event']]
    }]
  });
})();
class MultiselectDropdownModule {
  /** @nocollapse */static {
    this.ɵfac = function MultiselectDropdownModule_Factory(t) {
      return new (t || MultiselectDropdownModule)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MultiselectDropdownModule
    });
  }
  /** @nocollapse */
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [{
        provide: I18NEXT_NAMESPACE,
        useValue: ComponentKeys.TRANSLATION_NAMESPACE
      }],
      imports: [CheckboxModule, CommonModule, FormsModule, SpinnerModule, SvgSpriteIconModule, TextInputModule, TranslationModule, OverflowTooltipModule, InfiniteScrollingModule, SelectedTagsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(MultiselectDropdownModule, [{
    type: NgModule,
    args: [{
      declarations: [MultiselectDropdownComponent, MultiselectDropdownItemComponent, HighlightPipe],
      imports: [CheckboxModule, CommonModule, FormsModule, SpinnerModule, SvgSpriteIconModule, TextInputModule, TranslationModule, OverflowTooltipModule, InfiniteScrollingModule, SelectedTagsModule],
      providers: [{
        provide: I18NEXT_NAMESPACE,
        useValue: ComponentKeys.TRANSLATION_NAMESPACE
      }],
      exports: [MultiselectDropdownComponent]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { MultiselectDropdownComponent, MultiselectDropdownModule };
